import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import ResponsePreviewListItem from '../../ListItems/ResponsePreview';
import NothingToShow from '../../ListItems/NothingToShow';

const Responses = ({ closeSnackbar , ...props }) => {
  const classes = useStyles();
  const onInstancePress = React.useCallback(
    ({ instanceId, propertyId }) => props.history.push(`/map?property=${propertyId}&response=${instanceId}`),
    [props.history, props.match]
  );

  const isValidInstance = instance => {
    const property = props.propertiesById[instance.propertyId];
    return property !== undefined && !property.isDeleted && property.instanceId === instance.instanceId;
  };

  const instances = Object.values(props.instancesById)
    .filter(instance => isValidInstance(instance))
    .map(instance => {
      const propertyEvents = Object.values(instance.propertyEvents.byId).reverse();
      const lastVisitedTimestamp = instance.lastVisited;
      let unreadMessagesCount;
      if (lastVisitedTimestamp !== null) {
        unreadMessagesCount = 0;
        for (const propertyEvent of propertyEvents) {
          if (propertyEvent.createdAt > lastVisitedTimestamp) {
            unreadMessagesCount = unreadMessagesCount + 1;
          }
        }
      } else {
        if (propertyEvents.length > 0) {
          unreadMessagesCount = propertyEvents.length;
        } else {
          unreadMessagesCount = 1;
        }
      }
      return {
        key: instance.instanceId,
        unreadMessagesCount,
        senderId: propertyEvents.length > 0 ? propertyEvents[0].senderId : null,
        propertyId: instance.propertyId,
        lastMessage: propertyEvents.length > 0 ? propertyEvents[0].text : 'No messages',
        timestamp: propertyEvents.length > 0 ? propertyEvents[0].createdAt : instance.createdAt,
        onClick: () => {
          onInstancePress({ instanceId: instance.instanceId, propertyId: instance.propertyId });
          closeSnackbar();
        }
      };
    })
    .sort((a, b) => b.timestamp - a.timestamp)
    .map(listItem => (
      <ResponsePreviewListItem
        key={listItem.key}
        userId={listItem.senderId}
        lastMessage={listItem.lastMessage}
        timestamp={listItem.timestamp}
        unreadMessagesCount={listItem.unreadMessagesCount}
        propertyId={listItem.propertyId}
        onClick={listItem.onClick}
      />
    ));

  return (
    <List
      subheader={
        <ListSubheader className={classes.subheader}>{`Active responses \u2022 ${instances.length}`}</ListSubheader>
      }
    >
      {
        instances.length === 0 ? (
          <NothingToShow />
        ) : (
          instances
        )
      }
    </List>
  );
};

const useStyles = makeStyles(theme => ({
  subheader: { backgroundColor: 'white', zIndex: 100 }
}));

const mapStateToProps = state => ({
  propertiesById: state.properties.byId,
  instancesById: state.properties.instances.byId,
  divisionsById: state.divisions.byId,
  appUser: state.users.byId[state.auth.user.username]
});

export default withSnackbar(connect(mapStateToProps)(withRouter(Responses)));